export default __webpack_public_path__ + "static/media/settings.8cb5b3be.svg";